import { render, staticRenderFns } from "./DesignService.vue?vue&type=template&id=86eddf54&"
import script from "./DesignService.vue?vue&type=script&lang=js&"
export * from "./DesignService.vue?vue&type=script&lang=js&"
import style0 from "./DesignService.vue?vue&type=style&index=0&id=86eddf54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports